import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface StopIncompleteManagementIconProp extends Omit<SvgIconProps, `color`> {
  color?: string;
}

export const StopIncompleteManagementIcon = ({
  color = RoutalPalette.stopStatusColors.incomplete.dark,
  style,
  ...props
}: StopIncompleteManagementIconProp) => {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25" style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1323 5.37597C20.6283 4.34397 19.9083 3.43197 18.9963 2.63997C18.0723 1.84797 16.9923 1.23597 15.7923 0.815969C14.5803 0.383969 13.3083 0.167969 12.0003 0.167969C9.3603 0.167969 6.8763 1.04397 5.0043 2.63997C3.1443 4.23597 2.1123 6.34797 2.1123 8.59197C2.1123 11.88 3.6243 15.372 6.6243 18.96C7.5723 20.088 9.14431 21.816 11.3163 23.568L11.4243 23.652C11.5923 23.772 11.7963 23.832 12.0123 23.832C12.2283 23.832 12.4083 23.772 12.6243 23.628C12.6243 23.628 15.0363 21.828 17.4123 18.972C20.3523 15.432 21.9003 11.844 21.9003 8.60397C21.9003 7.48797 21.6483 6.40797 21.1443 5.37597H21.1323ZM7.17648 9.39143C6.90033 9.39143 6.67648 9.61529 6.67648 9.89143C6.67648 10.1676 6.90033 10.3914 7.17648 10.3914H16.8359C17.112 10.3914 17.3359 10.1676 17.3359 9.89143C17.3359 9.61529 17.112 9.39143 16.8359 9.39143H7.17648Z"
        fill={color}
      />
    </SvgIcon>
  );
};
